export default __webpack_public_path__ + "static/media/date.53ee7103.jpg";